import { Form } from 'src/app/models/form.model';
import { UserService } from './../../services/user.service';
import { MatDialog, } from '@angular/material/dialog';
import { MatSidenav, } from '@angular/material/sidenav';
import { MatIconRegistry, } from '@angular/material/icon';
import { Component, ViewChild, OnInit, TemplateRef } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BorradoresComponent } from '../borradores/borradores.component';
import { crearBorradorComponent } from '../borradores/crearBorrador/crearBorrador.component';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import * as FormActions from '../../reducers/actions/forms.actions';
import * as FinalFormactions from '../../reducers/actions/form_final.actions';
import { SidenavService } from 'src/app/services/sidenav.service';
import { SolicitudesExpComponent } from '../solicitudesexp/solicitudesexp.component';
import { DomSanitizer } from '@angular/platform-browser';
//import { ToastrService } from 'ngx-toastr';
import { Notification } from 'src/app/models/notification.model';
import * as NotificationActions from '../../reducers/actions/notification.actions';
import { FinalForm } from 'src/app/models/final_form.model';
import { GLOBAL } from 'src/app/services/global';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormBuilder, Validators } from '@angular/forms';

interface AppState {
  form: Form;
}
interface AppStateNotification {
  contador: Notification
}

interface AppStateFinalForm {
  formFinal: FinalForm
}
@Component({
  selector: 'main-nav',
  templateUrl: './main-nav.component.html',
  styleUrls: ['./main-nav.component.css'],
  providers: [SidenavService]

})
export class MainNavComponent implements OnInit {
  public materias = [];

  // public forms = GLOBAL.forms
  public formularios = [];
  public formularios2 = [];
  public forms = [];
  public forms2 = [];
  @ViewChild('drawer', { static: true }) public sidenav: MatSidenav;

  @ViewChild('mailSave') mailSave: TemplateRef<any>;

  isExpanded = true;
  showSubmenu: boolean = false;
  isShowing = false;
  showSubSubMenu: boolean = false;
  form: Observable<Form>
  identity;
  token;
  title;
  borradores = [];
  public activo;
  public notification_count;
  public contador_definitivo: Number
  public footer = GLOBAL.footer;
  public web = GLOBAL.web;
  public webUrl = GLOBAL.webUrl;
  public nombreMuni = GLOBAL.nombreMuni;
  // public showModule = GLOBAL.showModule;
  public acotado = GLOBAL.acotado;
  public mail;
  public expandedItem;
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches)
    );

  constructor(
    private breakpointObserver: BreakpointObserver,
    private dialog: MatDialog,
    private storeN: Store<AppStateNotification>,
    private _router: Router,
    private _userService: UserService,
    private store: Store<AppState>,
    private storeF: Store<AppStateFinalForm>,
    private _sidenavService: SidenavService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    ///private toastr: ToastrService,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService
  ) {

    this.matIconRegistry.addSvgIcon("obramenor", this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/permisos/obramenor.svg'))
      .addSvgIcon("edificacion", this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/permisos/edificacion.svg'))
      .addSvgIcon("subdivision", this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/permisos/houses.svg'))
      .addSvgIcon("division", this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/permisos/parquet.svg'))
      .addSvgIcon("copropiedad", this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/permisos/profiles.svg'))
      .addSvgIcon("catastrofes", this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/permisos/landslide.svg'))
      .addSvgIcon("antenas", this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/permisos/antenna.svg'))
      .addSvgIcon("regularizacion", this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/permisos/worker.svg'))
      .addSvgIcon("institucion", this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/permisos/fire-station.svg'))


    this.form = this.store.select('form')
    this.storeN.select('contador').subscribe(
      response => {
        this.contador_definitivo = response.contador
      },
      error => {
        console.error(error)
      }
    )
    localStorage.clear();
    sessionStorage.removeItem("borrador")


    // this.getSolic();
    this.getFormularios();
    this.mail = this.fb.group({
      email: ['', [Validators.pattern(this.regexp), Validators.required, Validators.maxLength(50)]],
    })

  }
  regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
  ngDoCheck() {
    this.expandedItem = sessionStorage.getItem("expandedItem")



  }

  ngOnInit() {
    console.log('se inicia muestra de form');
    if (!sessionStorage.getItem('identity-domCloud') || !sessionStorage.getItem('token-domCloud')) {
      this._router.navigate(['/']);
    } else {
      this.identity = this._userService.getIdentity();
      this.token = this._userService.getToken();
    }
    this._sidenavService.setSidenav(this.sidenav);


    var rut = this.identity.rut + this.identity.dv



    this._userService.askForMail(rut).subscribe(
      response => {
        if (response.status == true) {
          this.dialog.open(this.mailSave, { disableClose: true });
          this.spinner.hide()

        } else {
          this.spinner.hide()
        }
      },
      error => {
        console.log(error)
        this.spinner.hide()
      }
    )

  }

  verBorradores() {
    const formOptions = this.dialog.open(BorradoresComponent, {

    });
  }
  mouseenter() {
    if (!this.isExpanded) {
      this.isShowing = true;
    }
  }

  mouseleave() {
    if (!this.isExpanded) {
      this.isShowing = false;
    }
  }
  getForm(id?, title?, online?) {

    console.log('parametros 1', id);
    console.log('parametros 2', title);
    console.log('parametros 3', online);


    if (online) {

      localStorage.clear();
      sessionStorage.removeItem('borrador');
      this.store.dispatch(new FormActions.FormUpdate(id, title))

      this.storeF.dispatch(new FinalFormactions.FinalFormCreate({
        newFormValues: {
          formulario: '1.1',
          tipo_solicitud: 'prueba',
        }
      }))
      console.log('store', this.store);
      console.log('store g', this.storeF);

      setTimeout(() => {
        this.storeF.dispatch(new FinalFormactions.FinalFormCreate({
          newFormValues: {
            proyectos: []
          }
        }))
      }, 2000)
      console.log('es acotado ?', this.acotado);
      if (this.acotado == true) {
        localStorage.setItem("form", '0.1')
        localStorage.setItem("formId", id)
        localStorage.setItem("formTitle", title)
      } else {
        localStorage.setItem("form", id)
      }
      setTimeout(() => {
        this.sidenav.toggle(false);
      }, 200)

      console.log('linea244s');
      this._userService.formMostUsed(id, title).subscribe(
        response => {
          console.log(response, 'funciono')
        },
        error => {
          console.log('!!!!!!!!!!!!error formMostUsed', error)
        }
      )
    }
    else {
      alert("El formulario seleccionado solo se puede realizar presencialmente")
    }

  }
  saveDraft() {
    this.dialog.open(crearBorradorComponent)
  }
  back() {
    this.store.dispatch(new FormActions.FormUpdate('0', ''))
    localStorage.clear();
    sessionStorage.removeItem('borrador');
    this._router.navigate(['/inicio'])
  }

  logout() {
    this.store.dispatch(new FormActions.FormUpdate('0', ''))
    sessionStorage.removeItem("identity-domCloud");
    sessionStorage.removeItem("token-domCloud");
    this._router.navigate(['/inicio']);
  }

  inicio() {
    this._router.navigate(['/']);
  }

  getSolicitudes() {
    this.dialog.open(SolicitudesExpComponent);
  }

  getFormularios() {
    this._userService.getFormularios().subscribe(
      (response) => {


        this.materias = response.materias;
        console.log("response", response.materias)
      },
      error => {
        console.log("main-nav.component.ts error", error)
      });
  }

  getForms() {
    this._userService.getForms().subscribe(
      (response) => {
        // console.log("getForms response", response.forms)
        this.formularios = response.forms;
        for (let index = 0; index < this.formularios.length; index++) {
          const element = this.formularios[index];
          this.forms[element.num] =
          {
            "name": element.name,
            "active": element.active,
            "counter": element.counter,
          }
        }
        this.forms.length = this.formularios.length;
        console.log("this.forms", this.forms)
      },
      error => {
        console.log("main-nav.component.ts error", error)
      });

  }
  getSolic() {
    //console.log("Entre en los forms")
    this.notification_count = 0;
    var contador = 0;
    this._userService.getSolicitudes().subscribe(
      response => {
        console.log("getSolic response", response)
        for (let index = 0; index < response.length; index++) {
          const element = response[index];
          if (element.fieldData.Estado == 3 && (element.fieldData.Notificado == "" || element.fieldData.Notificado == null)) {
            this.notification_count++;
          }
          if (contador == (response.length - 1)) {
            this.storeN.dispatch(new NotificationActions.NotificationUpdate(this.notification_count))
            if (contador > 0 && this.nombreMuni != 'Lo Barnechea') {
              ////////this.toastr.warning('Pre-ingresos Rechazados', `Tienes ${this.notification_count} solicitude(s) de expediente rechazadas`);

            }
          }
          contador++;
        }

        // this.getForms();
        this.getFormularios();

      },
      error => {
        console.log("main-nav.component.ts error", error)
      })
  }


  submitMail() {
    this.spinner.show()
    var rut = this.identity.rut + this.identity.dv

    console.log(this.mail.value.email)
    this._userService.saveNewMail(rut, this.mail.value.email).subscribe(
      response => {
        console.log(response)
        alert(response.message)
        this.dialog.closeAll()
        this.spinner.hide()
      },
      error => {
        console.log(error)
        this.spinner.hide()
      }
    )
  }

}